const loginTranslation = {
  mode: 'en',

  loginError: 'Login Error',
  notAllowedErrorMessage1: 'Unauthorized account.',
  notAllowedErrorMessage2: 'Error: Please contact the administrator.',
  loginErrorMessage1: 'Temporary server or network error.',
  loginErrorMessage2: 'Please try again later.',
  loginErrorMessage3: 'Login failed.',
  loginErrorMessage4: 'Error: Please contact the administrator.',
  keyLoginErrorMessage1: 'Login key does not match.',
  keyLoginErrorMessage2: 'Please check again.',
  adminUserNotFoundMessage1: 'Admin account not found.',
  adminUserNotFoundMessage2: 'Please verify the account information.',
  configErrorMessage1: 'Login configuration error occurred.',
  configErrorMessage2: 'Please contact the administrator.',
  loginRetryMessage1: 'Login expired or failed.',
  loginRetryMessage2: 'Please try logging in again.',
  permissionErrorMessage1: 'Access denied.',
  permissionErrorMessage2: 'Please contact the administrator for permission.',
  login: 'LifeX Member Login',
  inputKey: 'Enter Key',
  keyLogin: 'Key Authentication',
  keycloakLogin: 'Sign in',
  googleLogin: 'Sign in with Google',
  logout: 'Logout',
  redirecting: 'Redirecting to login...',
  processingLogin: 'Processing login...',
  redirectingToLogin: 'Redirecting to login page...',
};

export default loginTranslation;
